import React, { useState, useContext, createContext} from 'react';
import PropTypes from 'prop-types';

import { ClickAwayListener, Popper, List, ListItem } from '@material-ui/core';


import './style.scss';
import Icon from '../Icon';
import Button from '../ActualButton'

const Context = createContext()

const DropdownItem = ({ onClick, children, className='', ...props }) => {
	const handleClose = useContext(Context);
	return (
		<ListItem onClick={(e) => {
			handleClose()
			onClick(e)
			}} className={`dropdown-action ${className}`} {...props}>
			{children}
		</ListItem>
	);
};

const DropdownMenu = ({ buttonText, disabled, children, className="", ...props }) => {
	const [anchorEl, setAnchorEl] = useState(null);
	const [arrowRef, setArrowRef] = useState(null);
	

	const open = Boolean(anchorEl);
	const id = open ? 'simple-popover' : undefined;

	const handleClick = (event) => {
		setAnchorEl(anchorEl ? null : event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const handleArrowRef = (node) => {
		setArrowRef(node);
	};

	return (
		<ClickAwayListener onClickAway={handleClose}>
			<div className={className}>
				<Button disabled={disabled} onClick={handleClick} primary>
						{buttonText}<Icon>keyboard_arrow_down</Icon>
				</Button>
				<Popper
					id={id}
					className="dropdown-menu__menu-container"
					placement="bottom"
					open={open}
					anchorEl={anchorEl}
					modifiers={{
						arrow: {
							enabled: true,
							element: arrowRef
						}
					}}
					{...props}
				>
					<span className="dropdown-menu__menu-arrow" ref={handleArrowRef} />
					<div className="dropdown-menu__menu-items">
						<List disablePadding>
							<Context.Provider value={handleClose}>
								{children}
							</Context.Provider>
						</List>
					</div>
				</Popper>
			</div>
		</ClickAwayListener>
	);
};

DropdownMenu.propTypes = {
	buttonText: PropTypes.string,
	disabled: PropTypes.bool,
	className: PropTypes.string,
	children: PropTypes.node
};
DropdownItem.propTypes = {
	onClick: PropTypes.func,
	className: PropTypes.string,
	children: PropTypes.node
};


export { DropdownItem, DropdownMenu };
